import { v4 } from "uuid";
import { ViewColumn } from "./view-column";

export const VIEW_SIDEBAR_FIELDS_BLOCK = "fields";

export class ViewSidebarBlock {
	uid:string = v4();
	Type:string = VIEW_SIDEBAR_FIELDS_BLOCK;
	Title:string = "";
	Fields:ViewColumn[] = [];
	Collapsed:boolean = false;
	Columns:number = 1;

	constructor(data?:any) {
		if (!data) return;
		this.Columns = data.Columns == 2 ? 2 : 1;
		this.Type = data.Type || VIEW_SIDEBAR_FIELDS_BLOCK;
		this.Title = data.Title || "";
		this.Fields = (data.Fields || []).map((f:any)=>new ViewColumn(f));
		this.Collapsed = data.Collapsed || false;
	}

	get isFieldsBlock():boolean {
		return this.Type == VIEW_SIDEBAR_FIELDS_BLOCK;
	}

	getPreloads():string[] {
		let result:string[] = [];
		for (let field of this.Fields) {
			let parts = field.Property.split(".");
			if (parts.length > 1) {
				parts.pop();
				result.push(parts.join("."));
			}
			if (field.IsComputed) {
				result.push(...(field.ComputedPreloads || []));
			}
		}
		return result;
	}

	getJSON():any {
		return {
			Type: this.Type,
			Title: this.Title,
			Fields: this.Fields,
			Collapsed: this.Collapsed,
			Columns: this.Columns
		};
	}
}
